import { IAdminSupplementInquiryDetails } from '@interfaces/adminSupplements';
import {
  IDietarySupplementDetails,
  IUserEnteredSupplementDataWithComments,
  TAdminResponseType,
} from '@interfaces/supplements';

import { TNewSupplementResponseMode } from './NewSupplement.interface';

export const convertAdminSupplementDetailsIntoFormValues = (
  data: IAdminSupplementInquiryDetails,
): IUserEnteredSupplementDataWithComments => ({
  adminResponseType: data.adminResponseType,
  comments: data.comments,
  companyName: data.supplementCompanyName,
  linkToProductPage: data.productLink,
  supplementCategoryId: data.supplementCategoryId,
  supplementName: data.name,
});

export const convertUserSupplementDetailsIntoFormValues = (
  data: IDietarySupplementDetails,
): IUserEnteredSupplementDataWithComments => ({
  adminResponseType: data.adminResponseType,
  comments: data.comments,
  companyName: data.companyName,
  linkToProductPage: data.productLink,
  supplementCategoryId: data.supplementCategoryId,
  supplementName: data.name,
});

export const getInitialValues = (
  adminSupplementDetails: IAdminSupplementInquiryDetails | null,
  matchingSupplementDetails: IDietarySupplementDetails | null,
): Partial<IUserEnteredSupplementDataWithComments> => {
  if (matchingSupplementDetails)
    return convertUserSupplementDetailsIntoFormValues(matchingSupplementDetails);
  if (adminSupplementDetails)
    return convertAdminSupplementDetailsIntoFormValues(adminSupplementDetails);
  return {};
};

export const convertAdminResponseTypeIntoResponseMode = (
  adminResponseType?: TAdminResponseType | null,
) => {
  switch (adminResponseType) {
    case TAdminResponseType.NeedsInfo:
      return TNewSupplementResponseMode.NeedMoreInfo;
    case TAdminResponseType.Medication:
      return TNewSupplementResponseMode.MarkAsMedication;
    default:
      return TNewSupplementResponseMode.CreateNew;
  }
};
